import { render } from "./LoadingPic.vue?vue&type=template&id=4c3f700e"
import script from "./LoadingPic.vue?vue&type=script&lang=js"
export * from "./LoadingPic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__